export default "__VITE_ASSET__DyYbgtpO__"